import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { HELP_DOC_THEME, HELP_DOC_TYPOGRAPHY } from './helpTheme';

export interface HelpSectionProps {
  id: string;
  title: string;
  subtitle?: string;
  defaultExpanded?: boolean;
  children: React.ReactNode;
}

const HelpSection: React.FC<HelpSectionProps> = ({
  id,
  title,
  subtitle,
  defaultExpanded = true,
  children,
}) => {
  return (
    <Accordion
      id={id}
      defaultExpanded={defaultExpanded}
      disableGutters
      elevation={0}
      sx={{
        border: 1,
        borderColor: HELP_DOC_THEME.border,
        borderRadius: '14px',
        mb: 1.1,
        bgcolor: HELP_DOC_THEME.contentBg,
        '&:before': { display: 'none' },
        '&.Mui-expanded': { my: 0 },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: HELP_DOC_THEME.textMuted }} />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
      >
        <Box sx={{ fontFamily: HELP_DOC_THEME.fontBody }}>
          <Typography
            component="div"
            sx={{
              fontWeight: 700,
              fontSize: HELP_DOC_TYPOGRAPHY.h3.fontSize,
              lineHeight: HELP_DOC_TYPOGRAPHY.h3.lineHeight,
              color: HELP_DOC_THEME.text,
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              component="div"
              sx={{
                fontSize: '14px',
                lineHeight: HELP_DOC_TYPOGRAPHY.lineHeight,
                color: HELP_DOC_THEME.textMuted,
                mt: '4px',
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0, pb: '16px', px: '12px' }}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default HelpSection;
